export const WarningMessageIds = {
  HOME_VALUE: 1,
};
